const TABS = [
  { key: "queue", label: "Active" },
  { key: "completed", label: "Completed" },
  { key: "failed", label: "Failed" },
];

export default function JobTabs({
  activeTab,
  setActiveTab,
  counts = {},
  setSelectedJob,
}) {
  const selectTab = (key) => {
    if (key === activeTab) return;
    setActiveTab(key);
    setSelectedJob?.(null);
  };

  return (
    <div
      role="tablist"
      aria-label="Analysis jobs"
      className="mb-4 flex gap-0.5 overflow-x-auto rounded-lg bg-gray-100 p-0.5"
    >
      {TABS.map(({ key, label }) => {
        const selected = activeTab === key;
        const count = Number(counts[key] || 0);

        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => selectTab(key)}
            className={`inline-flex min-w-fit flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-[11px] font-semibold transition focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 ${
              selected
                ? "bg-white text-gray-950 shadow-sm"
                : "text-gray-500 hover:bg-white/60 hover:text-gray-800"
            }`}
          >
            {label}
            <span
              className={`inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-bold ${
                selected
                  ? "bg-indigo-100 text-indigo-700"
                  : "bg-gray-200 text-gray-600"
              }`}
            >
              {count > 99 ? "99+" : count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
